export default __webpack_public_path__ + "static/media/unique-designs.65ca4988.svg";